module.exports = __webpack_public_path__ + "static/img/r-3-3-icon.a67a92e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/layer3/en/role-3/r-3-3-icon.png
// module id = xZ3k
// module chunks = 0